module.exports = __webpack_public_path__ + "img/1f34d.5980ff3.svg";